import React from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import styles from './ParallaxBackground.module.css';

const ParallaxShape = ({ className, speed, top, left, right, bottom }) => {
    const { scrollY } = useScroll();
    const y = useTransform(scrollY, [0, 1000], [0, speed * 100]);

    return (
        <motion.div
            className={`${styles.shape} ${className}`}
            style={{ y, top, left, right, bottom }}
        />
    );
};

const ParallaxBackground = () => {
    return (
        <div className={styles.container}>
            <ParallaxShape className={styles.circleLarge} speed={-2} top="10%" left="-5%" />
            <ParallaxShape className={styles.circleSmall} speed={1} top="20%" right="10%" />
            <ParallaxShape className={styles.square} speed={-1} top="40%" left="15%" />
            <ParallaxShape className={styles.circleMedium} speed={2} top="60%" right="-5%" />
            <ParallaxShape className={styles.triangle} speed={-1.5} top="80%" left="10%" />
        </div>
    );
};

export default ParallaxBackground;
